var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"select-filter",attrs:{"solo":"","flat":"","dense":"","background-color":"background","items":_vm.sortOptions,"value":_vm.value,"hide-details":""},on:{"change":_vm.handleSortFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }